import React from 'react';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import classNames from 'classnames';

import { CategoryAttributeLevel as CategoryAttributeLevelType, CategoryAttributeLevelSelected } from '../../../../../types';

import styles from '../scoutingForm.css';

export type CategoryAttributeProps = {
  attribute: string;
  levels: CategoryAttributeLevelType[];
  attributesSelected: CategoryAttributeLevelSelected;
  setAttributesSelected: React.Dispatch<React.SetStateAction<CategoryAttributeLevelSelected>>
  testId: string;
}

export function CategoryAttribute({ 
  attribute,
  attributesSelected,
  setAttributesSelected,
  levels,
  testId
}: CategoryAttributeProps) {
  const onLevelClick = ({ attribute, levelId }: { attribute: string, levelId: string }) => {
    if (attributesSelected[attribute] === levelId) {
      setAttributesSelected((prev) => {
        const newSelection = { ...prev };
        delete newSelection[attribute];
        return newSelection;
      });
    } else {
      setAttributesSelected(prev => ({ ...prev, [attribute]: levelId }));
    }
  }

  return (
    <div className={styles.categorySelectorAttributesRow} data-test-id={testId}>
      <div 
        className={styles.categorySelectorAttributesTitleContainer}
        data-test-id={`${testId}-title-container`}
      >
        <div className={styles.categorySelectorAttributesTitle} data-test-id={`${testId}-title`}>
          {getMessage(`enhancedScouting.form.attribute.${attribute.toLowerCase()}`)}
        </div>
      </div>

      <div className={styles.categorySelectorAttributesContent} data-test-id={`${testId}-levels`}>
        {levels.map(({ id, level }) => (
          <CategoryAttributeLevel
            key={id}
            level={level}
            selected={attributesSelected[attribute] === id}
            onClick={() => onLevelClick({ attribute, levelId: id })}
            testId={`${testId}-${level}`}
          />
        ))}
      </div>
    </div>
  );
}

type CategoryAttributeLevelProps = {
  level: string;
  selected: boolean;
  testId: string;
  onClick: () => void;
}

function CategoryAttributeLevel({ level, selected, onClick, testId }: CategoryAttributeLevelProps) {
  return (
    <div
      className={
        classNames(
          styles.categorySelectorAttributesOption,
          selected ? styles.categorySelectorAttributesOptionSelected : '')}
      onClick={onClick}
      data-test-id={testId}
    >
      {selected
        ? <Icon
          className={styles.categorySelectorAttributesOptionSelectedIcon}
          glyph={Icon.set.MATERIAL_CHECK}
          testId={`${testId}-selected`}
        />
        : null
      }
      {getMessage(`enhancedScouting.form.attribute.level.${level.toLowerCase()}`)}
    </div>
  );
}
